<template>
  <svg
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="32.5"
      cy="32.5"
      r="24.375"
      stroke="url(#paint0_linear_3360_12313)"
      stroke-width="3"
    />
    <path
      d="M24.375 40.625L40.625 24.375M40.625 40.625L24.375 24.375"
      stroke="url(#paint1_linear_3360_12313)"
      stroke-width="3"
      stroke-linejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3360_12313"
        x1="56.875"
        y1="36.2961"
        x2="8.59289"
        y2="41.0491"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3360_12313"
        x1="40.625"
        y1="33.7654"
        x2="24.531"
        y2="35.3497"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
    </defs>
  </svg>
</template>
